import styled from 'styled-components';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding-bottom: 80px;

  @media ${breakpoint.md} {
    padding-bottom: 160px;
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h5`
  margin: 0;
  font-family: var(--executive-website-heading-font-family);
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
`;
